<script setup lang="ts">
import type { PastModels } from '#shared/interfaces/model-top/pastModels'
import { TRANSITION_SOURCE } from '#shared/constant/constant'
import type { SendNewcarSearch } from '@/interfaces/searchUsedCar'
import { postWindowBridge } from '@/utils/windowBridge'

const {
  pastModels = undefined,
  carModelCd,
  currentModelFlg = undefined,
} = defineProps<{
  pastModels?: PastModels
  carModelCd: string
  currentModelFlg?: boolean
}>()

const nuxtApp = useNuxtApp()
const toNextPage = (carCd: number, modelCd: number) => {
  const route = useRoute()
  const query = route.query
  const pastCarModelCd = carCd + '_' + modelCd
  const eventName = currentModelFlg
    ? 'CatalogCurrentMdlTopHistoryMdlListTap'
    : 'CatalogPastMdlTopHistoryMdlListTap'
  nuxtApp.$sendEventGaTag(eventName)
  if (
    query.transition_source === TRANSITION_SOURCE.newcar_search &&
    pastCarModelCd !== carModelCd
  ) {
    const sendNewcarSearch: SendNewcarSearch = {
      url: `${useRuntimeConfig().public.BASE_URL}/model-top/${pastCarModelCd}`,
    }
    if (
      postWindowBridge('transitionCatalogApp', JSON.stringify(sendNewcarSearch))
    )
      return
  }
  if (pastCarModelCd !== carModelCd) {
    navigateTo({
      path: '/model-top/' + pastCarModelCd,
      query: route.query,
    })
  }
}
</script>
<template>
  <div
    v-if="pastModels && pastModels.models.length !== 0"
    id="pastModel"
    class="contents"
  >
    <div class="successive-model-title">歴代モデル一覧</div>
    <div class="successive-model-index shadow-sm">
      <div
        v-for="(pastModel, index) in pastModels.models"
        :key="pastModel.model_cd"
        class="successive-model-cassette"
        :class="pastModels.models.length === index + 1 ? 'last-caset' : ''"
        @click="toNextPage(pastModel.car_cd, pastModel.model_cd)"
      >
        <img
          :src="pastModel.image_file"
          class="car-img"
          onerror="
            this.src = 'https://img.goo-net.com/goo/usedcar/nophoto_big.jpg'
          "
          loading="lazy"
        />
        <div
          class="sales-status"
          :class="pastModel.current_model_flg ? '' : 'not-current-sales-status'"
        >
          <div v-if="pastModel.current_model_flg" class="tags">
            <div class="tags-word">現行販売車</div>
          </div>
          <div
            class="car-name"
            :class="pastModel.current_model_flg ? '' : 'not-current-carname'"
          >
            <span>{{ pastModel.brand_name + ' ' }}</span>
            <span>{{ pastModel.car_name + ' ' }}</span>
            <span>{{ pastModel.model_name }}</span>
          </div>
          <div
            v-if="pastModel.current_model_flg && pastModel.sales_start_date"
            class="sales-period"
          >
            {{ pastModel.sales_start_date_jpn + '〜現行販売車' }}
          </div>
          <div
            v-else-if="pastModel.sales_start_date && pastModel.sales_end_date"
            class="sales-period"
          >
            {{
              pastModel.sales_start_date_jpn +
              '〜' +
              pastModel.sales_end_date_jpn
            }}
          </div>
        </div>
        <div
          v-if="pastModel.car_cd + '_' + pastModel.model_cd !== carModelCd"
          class="arrow-right"
        >
          <img
            class="arrow-right-img"
            style="width: 24px; height: 24px"
            src="@/assets/image/icon/arrow_right.svg"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.successive-model-title {
  font-size: 20px;
  font-weight: bold;
  margin-top: 48px;
  margin-left: 16px;
  margin-bottom: 19px;
}
.successive-model-index {
  background-color: #ffffff;
}
.successive-model-cassette {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d5d5d5;
  margin-left: 11px;
}
.last-caset {
  border-bottom: none !important;
}
.sales-status {
  padding-left: 6px;
  margin-bottom: 7px;
}

.not-current-sales-status {
  margin-bottom: 19px !important;
}
.tags {
  background-color: #000;
  color: #fff !important;
  border-radius: 2px;
  font-size: 10px;
  display: flex;
  width: 58px;
  min-height: 18px;
  align-items: center;
  margin-top: 7px;
}
.tags-word {
  margin: 0 auto;
}
.not-current-carname {
  margin-top: 17px;
}
.car-name {
  font-size: 12px;
  font-weight: bold;
}
.sales-period {
  font-size: 11px;
}
.car-img {
  width: 90px;
  height: 45px;
  margin-top: 7px;
  margin-bottom: 11px;
  vertical-align: middle;
  object-fit: cover;
}
.arrow-right-img {
  margin-right: 11px;
}
.arrow-right {
  margin-left: auto;
}
</style>
